// extracted by mini-css-extract-plugin
module.exports = {"row":"_6de8b80d","priceLabel":"_6e2beb4c","topLine":"_912bf1a2","priceStrike":"_13e75f78"};